import apollo from '@/graphql'

import RetailersQuery from '@/graphql/retailer/RetailersQuery.gql'

// initial state
const state = {
  retailers: [],
}

// getters
const getters = {
  retailers: st => st.retailers,
}

const mutations = {
  setRetailers(st, retailers) {
    state.retailers = retailers
  },
}

// actions
const actions = {
  loadRetailers({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: RetailersQuery,
    }).subscribe(({ data: { retailers } }) => {
      commit('setRetailers', retailers)
    })
  },
}


export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/retailer/RetailerList.js